// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2yIpw","profileLogo":"styles_profileLogo__bvEmX","icon":"styles_icon__1xy1j"};